import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ProductCarouselThumbnailNavButton } from '../ProductCarouselThumbnails/ProductCarouselThumbnailNavButton'

import { ProductCarouselGallery } from './ProductCarouselGallery/ProductCarouselGallery'
import { type ProductCarouselGalleryWithSideButtonsProps } from './ProductCarouselGalleryWithSideButtonsProps'

const MIN_NUMBER_OF_IMAGES = 2

const ProductCarouselGalleryWithSideButtons: FC<
  ProductCarouselGalleryWithSideButtonsProps
> = ({
  currentImageIndex,
  images,
  onImageScrolledInView,
  onItemClick,
  onSideButtonClick,
  onTabNavigation,
  playVideoOnClick,
  playVideoOnScrolledIntoView,
  productName,
  showSimilarImagesNotice = false,
  useLargeImageSizes,
  videos,
  withLeftRightButtons,
  zoomEnabled,
}) => {
  const enableSideButtons =
    withLeftRightButtons &&
    images.length + videos.length >= MIN_NUMBER_OF_IMAGES

  return (
    <div className="relative mb-3.5 block w-full before:block before:pt-[100%]">
      {enableSideButtons && onSideButtonClick && currentImageIndex !== 0 ? (
        <ProductCarouselThumbnailNavButton
          className="group absolute -left-7 top-1/2 -mt-3.5 size-7"
          disabled={false}
          onClick={(): void => {
            onSideButtonClick(currentImageIndex - 1)
          }}
        />
      ) : null}
      <ProductCarouselGallery
        currentImageIndex={currentImageIndex}
        images={images}
        onImageScrolledInView={onImageScrolledInView}
        onItemClick={onItemClick}
        onTabNavigation={onTabNavigation}
        playVideoOnClick={playVideoOnClick}
        playVideoOnScrolledIntoView={playVideoOnScrolledIntoView}
        productName={productName}
        useLargeImageSizes={useLargeImageSizes}
        videos={videos}
        zoomEnabled={zoomEnabled}
      />
      {enableSideButtons &&
      onSideButtonClick &&
      currentImageIndex !== images.length + videos.length - 1 ? (
        <ProductCarouselThumbnailNavButton
          className="group absolute -right-7 top-1/2 -mt-3.5 size-7"
          disabled={false}
          isRightButton
          onClick={(): void => {
            onSideButtonClick(currentImageIndex + 1)
          }}
        />
      ) : null}
      {showSimilarImagesNotice ? (
        <div
          className="absolute -left-28 top-1/2 -translate-y-1/2 -rotate-90 tablet:-left-36"
          data-qa-id="product-similar-image"
        >
          <FormattedMessage id="product.details.gallery.caption.similarImage" />
        </div>
      ) : null}
    </div>
  )
}

export { ProductCarouselGalleryWithSideButtons }
